var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admission-note-container" },
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          "left-side-class": "col-md-6",
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-md-6  align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _vm.admissionNoteInfo &&
      _vm.admissionInfo.studentServiceId &&
      !_vm.isSignHubActive
        ? _c("admission-note-document", {
            attrs: {
              "admission-id": _vm.admissionId,
              "admission-note-id": _vm.admissionNoteInfo.id,
              "student-service-id": _vm.admissionInfo.studentServiceId
            }
          })
        : _vm._e(),
      _c("board", { attrs: { details: _vm.invoiceDetailsBoard } }),
      _c(
        "validation-observer",
        { ref: "admissionNote" },
        [
          _vm.isSignHubActive
            ? _c(
                "b-tabs",
                {
                  staticClass: "mt-3",
                  attrs: {
                    "nav-class": "custom-nav-container",
                    "no-nav-style": true
                  },
                  model: {
                    value: _vm.tabModel,
                    callback: function($$v) {
                      _vm.tabModel = $$v
                    },
                    expression: "tabModel"
                  }
                },
                [
                  _c(
                    "b-tab",
                    { attrs: { active: true, title: "Nota de Admisión" } },
                    [
                      _vm._l(_vm.sections, function(section, idx) {
                        return _c(
                          "div",
                          { key: idx },
                          [
                            _c("admission-note-section", {
                              ref: `section-${section.sectionType}`,
                              refInFor: true,
                              attrs: {
                                "read-only": _vm.readOnly,
                                "section-data": section
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c("validation-provider", {
                        attrs: { rules: { required: { allowFalse: false } } },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ validate: _validate, errors }) {
                                return [
                                  _c("custom-signature", {
                                    staticClass: "mt-4",
                                    attrs: {
                                      "activation-button-text":
                                        "Presione aquí para añadir firma del especialista",
                                      "allow-add-more": "",
                                      "apply-signature": false,
                                      "cannot-edit-name": "",
                                      "icon-title": "fas fa-file-user",
                                      "keep-signed": "",
                                      "limit-new-signatures-to": 1,
                                      requesters: _vm.requesterModel,
                                      "specialist-data": {
                                        specialists: _vm.specialists,
                                        showSpecialistField: true
                                      },
                                      submitted: _vm.readOnly,
                                      title: "Firma de Participantes",
                                      "title-class":
                                        "section-container__section-title__info",
                                      "title-container-class":
                                        "section-container__section-title__container",
                                      "use-role": "",
                                      "user-profile": _vm.user.profile
                                    },
                                    on: { input: _validate }
                                  }),
                                  errors[0] && _vm.hasSignatureValidationError
                                    ? _c("error", {
                                        attrs: {
                                          message:
                                            "La Firma de Participante es requerida.",
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2177065909
                        )
                      })
                    ],
                    2
                  ),
                  _vm.canViewAdmissionSignTab
                    ? _c("b-tab", { attrs: { title: "Firmas" } }, [
                        _c(
                          "div",
                          { staticClass: "my-4" },
                          [
                            _c("sign-plan", {
                              key: _vm.admissionNoteInfo.id,
                              ref: "signPlanRef",
                              attrs: {
                                disabled: _vm.isElectronicDisabled,
                                "is-electronic-signature":
                                  _vm.isElectronicSignature,
                                "question-label":
                                  "¿Cuál será el mecanismo que se estará utilizando para firmar la Nota de Admisión?"
                              },
                              on: {
                                "update:isElectronicSignature": function(
                                  $event
                                ) {
                                  _vm.isElectronicSignature = $event
                                },
                                "update:is-electronic-signature": function(
                                  $event
                                ) {
                                  _vm.isElectronicSignature = $event
                                },
                                change: _vm.handleSelectMechanism
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "mt-4" },
                              [
                                _vm.hasSelectMechanisManuscript
                                  ? _c(
                                      "div",
                                      [
                                        _c("section-title", {
                                          attrs: {
                                            content: "Documento",
                                            "has-line": ""
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bg-secondary-13 rounded p-3"
                                          },
                                          [
                                            _c("admission-note-document", {
                                              ref: "admissionNoteDocument",
                                              attrs: {
                                                "admission-id": _vm.admissionId,
                                                "admission-note-id":
                                                  _vm.admissionNoteInfo.id,
                                                "student-service-id":
                                                  _vm.admissionInfo
                                                    .studentServiceId
                                              },
                                              on: {
                                                documentSaved:
                                                  _vm.handleAdmissionNoteSaved
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.hasSelectMechanismElectronic
                                  ? _c("signature-hub-info", {
                                      attrs: {
                                        "signature-info": _vm.signatureHubInfo
                                      },
                                      on: {
                                        "configure-sign":
                                          _vm.handleConfigureSignatures
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm._l(_vm.sections, function(section, idx) {
                    return _c(
                      "div",
                      { key: idx },
                      [
                        _c("admission-note-section", {
                          ref: `section-${section.sectionType}`,
                          refInFor: true,
                          attrs: {
                            "read-only": _vm.readOnly,
                            "section-data": section
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c("validation-provider", {
                    attrs: { rules: { required: { allowFalse: false } } },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ validate: _validate, errors }) {
                          return [
                            _c("custom-signature", {
                              staticClass: "mt-4",
                              attrs: {
                                "activation-button-text":
                                  "Presione aquí para añadir firma del especialista",
                                "allow-add-more": "",
                                "apply-signature": false,
                                "cannot-edit-name": "",
                                "icon-title": "fas fa-file-user",
                                "keep-signed": "",
                                "limit-new-signatures-to": 1,
                                requesters: _vm.requesterModel,
                                "specialist-data": {
                                  specialists: _vm.specialists,
                                  showSpecialistField: true
                                },
                                submitted: _vm.readOnly,
                                title: "Firma de Participantes",
                                "title-class":
                                  "section-container__section-title__info",
                                "title-container-class":
                                  "section-container__section-title__container",
                                "use-role": "",
                                "user-profile": _vm.user.profile
                              },
                              on: { input: _validate }
                            }),
                            errors[0] && _vm.hasSignatureValidationError
                              ? _c("error", {
                                  attrs: {
                                    message:
                                      "La Firma de Participante es requerida.",
                                    variant: "no-border"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }